export const downloadFileFromBlob = (
  fileName: string,
  data: any,
  options?: BlobPropertyBag
): void => {
  const file = new Blob([data], options);

  if ((window.navigator as any).msSaveOrOpenBlob) {
    (window.navigator as any).msSaveOrOpenBlob(file, fileName);
  } else {
    const a = document.createElement('a');
    const url = URL.createObjectURL(file);

    a.hidden = true;
    a.href = url;
    a.download = fileName;

    // Safari thinks _blank anchor are pop ups. We only want to set _blank
    // target if the browser does not support the HTML5 download attribute.
    // This allows you to download files in desktop safari if pop up blocking
    // is enabled.
    if (typeof a.download === 'undefined') {
      a.setAttribute('target', '_blank');
    }

    document.body.appendChild(a);
    a.click();

    setTimeout(() => {
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    });
  }
};

interface ImportFilePromptResult<Data = string> {
  fileName: string;
  data: Data;
}

export const promptDataFromFile = <Data = string>(
  type?: string
): Promise<ImportFilePromptResult<Data>> =>
  new Promise((resolve, reject) => {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.hidden = true;

    if (type) {
      fileInput.accept = type;
    }

    document.body.appendChild(fileInput);

    fileInput.onchange = (event: any) => {
      if (event.target && event.target.files) {
        const file = event.target.files[0];
        const fileReader = new FileReader();
        fileReader.onload = () => {
          if (fileReader.result && typeof fileReader.result === 'string') {
            resolve({
              fileName: file.name.split('.')[0],
              data: fileReader.result as any,
            });
            fileInput.remove();
          }
        };
        fileReader.addEventListener('error', reject);
        fileReader.readAsText(file);
      }
    };

    fileInput.click();
  });
